import PropTypes from 'prop-types'
import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@mui/joy'
import { getTaskDetails } from 'features/projectsSlice'
import { projectService } from 'services/projectsService'
import { getAdminUserAssignedHeaders } from 'utils/headers/getAdminUserAssignedHeaders'
import { handleErrorMessage, standarizeStatus } from 'utils/helpers'
import { STATUS } from 'utils/config'
import usePagination from 'hooks/usePagination'
import DeleteModal from 'components/DeleteModal'
import EnchantedTable from 'components/tables/EnchantedTable'

const AssignedUserSubView = ({ innerLoading, setInnerLoading }) => {
  const dispatch = useDispatch()
  const pagination = usePagination()
  const { enqueueSnackbar } = useSnackbar()
  const { projectId, taskId } = useParams()

  const { currentTask } = useSelector((s) => s.projects)

  const [unassignUserObject, setUnassignUserObject] = useState(false)

  const handleAction = (action, successMessage, callback) => {
    setInnerLoading(true)
    action
      .then((res) => {
        console.log(res)
        enqueueSnackbar(successMessage, { variant: 'success' })
        callback()
      })
      .catch((err) => {
        console.log(err)
        enqueueSnackbar(handleErrorMessage(err, 'Coś poszło nie tak.'), { variant: 'error' })
      })
      .finally(() => setInnerLoading(false))
  }

  const handleUnassignProjectTaskUser = (userId) => {
    handleAction(
      projectService.adminUnassignProjectTaskUser(projectId, taskId, userId),
      'Użytkownik został odpięty.',
      () => {
        setUnassignUserObject(false)
        dispatch(getTaskDetails({ projectId, taskId }))
      }
    )
  }

  if (!projectId || !taskId) return null

  return (
    <>
      <DeleteModal
        open={unassignUserObject}
        handleDelete={() => handleUnassignProjectTaskUser(unassignUserObject.userId)}
        loading={innerLoading}
        setObject={setUnassignUserObject}
        btnText="Odepnij"
      >
        Czy jesteś pewny, ze chcesz odpiąć:{' '}
        <Typography color="primary" fontWeight={500}>
          {unassignUserObject.firstName} {unassignUserObject.lastName}
        </Typography>
      </DeleteModal>
      <Typography color="primary" fontWeight={500} sx={{ mt: 2 }}>
        Przypisany:
      </Typography>
      <EnchantedTable
        headers={getAdminUserAssignedHeaders()}
        data={currentTask.assignment ? [{ ...currentTask.assignment }] : []}
        offset={(pagination.values.currentPage - 1) * pagination.values.perPage}
        noDataText="Brak przypisanej osoby."
        buttonActions={[
          {
            label: 'Odepnij',
            color: 'danger',
            func: (el) => setUnassignUserObject(el),
            loading: innerLoading,
            display: () => standarizeStatus(currentTask.status) !== STATUS.done.value,
          },
        ]}
      />
    </>
  )
}

export default AssignedUserSubView

AssignedUserSubView.propTypes = {
  setInnerLoading: PropTypes.func.isRequired,
  innerLoading: PropTypes.bool,
}
